<div class="w-full bg-(--neutral-darkest) relative">
  <div
    class="w-9/12 mx-auto flex flex-wrap lg:flex-nowrap text-white pt-10 pb-25"
  >
    <div class="lg:w-6/12 mb-5">
      <h1 class="text-5xl font-bold text-center">
        <img src="images/logo-white.svg " />
      </h1>
      <h4 class="mt-6 text-2xl font-semibold">Siga a Bemine Split</h4>
      <p class="mt-5 flex gap-4 text-lg">
        <a href="https://www.instagram.com/beminesplit/" target="_blank">
          <span
            class="text-2xl ph ph-instagram-logo text-secondary-light"
          ></span>
        </a>
        <a href="https://www.tiktok.com/@beminesplit" target="_blank">
          <span class="text-2xl ph ph-tiktok-logo text-secondary-light"></span>
        </a>
        <a
          href="https://www.facebook.com/people/Bemine-Split/pfbid0kBmEN5s8dZkXiM31MzVnQqDAJLc3FfeHw1uSRf2Gdv79S5oSTDh3G33jLtoJ9uchl/"
          target="_blank"
        >
          <span
            class="text-2xl ph ph-facebook-logo text-secondary-light"
          ></span>
        </a>
      </p>

      <h4 class="mt-6 text-2xl font-semibold">Contato</h4>
      <p class="flex gap-1 items-center mt-4 text-secondary-light">
        <i class="ph ph-whatsapp-logo text-2xl"></i>
        <a href="https://wa.me/16897775629" target="_blank"
          >Clique e fale conosco</a
        >
      </p>
    </div>
    <div
      class="lg:w-6/12 flex flex-wrap lg:flex-nowrap justify-start lg:justify-end gap-5 lg:gap-15"
    >
      <div class="lg:mb-5">
        <h2 class="text-2xl font-bold">Produtos</h2>
        <div class="mt-3 flex flex-col space-y-2">
          @for (item of productModels(); track item.id) {
            <a routerLink="/products" [queryParams]="{ model: item.id }">
              {{ item.name }}
            </a>
          }
          <a routerLink="/products"> Ver todos </a>
        </div>
      </div>
      <div class="lg:mb-5">
        <h2 class="text-2xl font-bold">Institucional</h2>
        <div class="mt-3 flex flex-col space-y-2">
          <a routerLink="/terms-of-use"> Termos de uso </a>
          <a routerLink="/privacy-policy"> Políticas de privacidade </a>
          <a routerLink="/" (click)="scrollToElement('about')"> Sobre nós </a>
          <a routerLink="/" (click)="scrollToElement('howWorks')">
            Como funciona
          </a>
          <a routerLink="/" (click)="scrollToElement('faq')">
            Perguntas frequentes
          </a>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full text-white text-center py-3 absolute bottom-0 p-2 lg:p-0">
    <p class="">
      &copy; {{ currentYear }} Bemine Split by LEND SOLUCOES EM PAGAMENTOS CORP.
    </p>
    <p class="mt-2 mb-5">Todos os direitos reservados.</p>
  </div>
</div>
